// eslint-disable-next-line no-restricted-imports
import styled from "@emotion/styled";

export const ButtonContainer = styled.div`
  display: flex;
`;
